
import React from 'react';
import { sprintf } from "sprintf-js";
import {AccountState} from "../../../lib/constants";
import { DwollaPaymentIds } from "../../../lib/dwolla/constants";
import { get_microdeposit_payment_id, get_microdeposit_too_many_attempts,
  funding_source_microdeposit_completed } from "../../../lib/dwolla/utils";
import {is_transfer, onboarding_start_segment} from "../../../lib/onboarding-utils";
import { getRGB } from "../../../lib/color";
import { Action, Spinner } from "../../funcs/utils";
import { PopupBorder } from "../../../lib/onboarding-shared/popup";
import { PopupContext } from "../BannerMenu/PopupContext";
import {deep_copy} from "../../../lib/js-utils";
import {objToUrlParam} from "../../../lib/url-util";
import {CreateAccountMenuData} from "./menu-data";

class AccountPopupMenu extends React.Component {

  static contextType = PopupContext;

  constructor(props) {
    super(props);
    this.state = {
      mouse_over_menu: -1,
    };
  }

  account_states = user => {
    const acctRE = /^account_\d\d\d\d_state$/;
    const state_props = Object.keys(user).filter(prop => acctRE.test(prop));
    state_props.sort();
    return state_props.map((prop, index) => {
      return {
        prop,
        index,
        index_prop: sprintf("%04d", index),
        state: user[prop],
      }
    });
  };

  onMenuMouseOver = (index, mouse_over) => ev => {
    if (mouse_over) {
      this.setState({
        mouse_over_menu: index,
      })
    } else {
      if (this.state.mouse_over_menu === index) {
        this.setState({
          mouse_over_menu: -1,
        })
      }
    }
  };

  isOnboarding = () => {
    const onboardingRE = /^\/onboarding_\d{4}\//;
    return this.props.path.match(onboardingRE);
  }

  dashboard_url = (acct_index = -1) => {

    const user = this.props.user;
    const args = this.props.args ? deep_copy(this.props.args) : {};
    const all_dwolla = this.props.dwolla;
    const all_onboarding = this.props.onboarding;
    let micro_dep_popup = false;

    if (acct_index === -1) {
      acct_index = user.loaded_acct_index;
    }
    const key = sprintf("%04d", acct_index);
    const acct_state = user.account_state[key];
    if (acct_state === AccountState.LIVE
      || acct_state === AccountState.CLOSED
      || acct_state === AccountState.RIA_PORTFOLIO
      || acct_state === AccountState.TDA_PORTFOLIO
      || acct_state === AccountState.TEST_PORTFOLIO) {
      args.acct_index = acct_index.toString();
      return "/user" + objToUrlParam(args);
    } else if (acct_state === AccountState.ONBOARDING) {
      const segment = onboarding_start_segment(this.props.app.wlf);
      return sprintf("/onboarding_%04d/%s", acct_index, segment);
    } else if (acct_state === AccountState.SIGNED) {
      const dwolla_key = sprintf("%04d", acct_index);
      const dwolla = all_dwolla[dwolla_key];
      const dwolla_0000 = all_dwolla['0000'];
      const onboarding = all_onboarding[dwolla_key];
      const payment_initiated = DwollaPaymentIds.FUNDING_0 in dwolla.payments;
      const micro_dep_id = get_microdeposit_payment_id(dwolla_0000);
      const too_many_id = get_microdeposit_too_many_attempts(dwolla_0000);
      micro_dep_popup = funding_source_microdeposit_completed(
        dwolla_0000, micro_dep_id);
      if (micro_dep_popup) {
        return sprintf("/onboarding_%04d/microdeposit_verify?%s", acct_index, micro_dep_id);
      }

      let page = null;
      if (micro_dep_id) {
        page = "signing_done?microdeposit_initiated=" + micro_dep_id;
      } else if (payment_initiated) {
        page = "payment_source"
      } else if (micro_dep_popup) {
        page = "microdeposit_verify?" + micro_dep_id;
      } else if (too_many_id) {
        page = "microdeposit_verify?" + too_many_id;
      } else if (!is_transfer(onboarding)) {
        page = "payment_source";
      } else if (is_transfer(onboarding)) {
        page = "signing_done";
      }

      if (page) {
        return sprintf("/onboarding_%04d/%s", acct_index, page);
      }
    }
  };

  onAccountMenuClick = index => () => {
    this.context.onMouseOver(this.props.menu_id, false)();
    if (this.props.set_menu_data) {
      if (this.props.menu_data) {
        const url = this.props.menu_data[index].url;
        this.props.navigatePath(url);
      }
    } else {
      this.props.navigatePath(this.dashboard_url(index));
    }
  };

  maybeRenderAggregate = () => {
    if (!this.props.show_aggregate) {
      return null;
    }
    const on_click = () => {
      this.context.onMouseOver(this.props.menu_id, false)();
      this.props.navigatePath(this.props.aggregate_url);
    }

    const header_style = {
      color: "#000",
      fontSize: "1rem",
      backgroundColor: this.state.mouse_over_menu === "aggregate" && "#DDD",
    };

    return (
      <div
        align={"center"}
        style={header_style}
        onClick={on_click}
        onMouseOver={this.onMenuMouseOver("aggregate", true)}
        onMouseOut={this.onMenuMouseOver("aggregate", false)}>
        <span>All Accounts</span>
      </div>
    );
  };

  maybeRenderAddAccount = () => {
    if (this.props.show_add_account) {
      const style = {
        padding: this.props.adding_account ? "0.2rem 1rem" : "0.2rem 0.5rem",
      }
      const text = this.props.adding_account
        ? (<Spinner/>)
        : (<span>Add Another Account</span>);
      return (
        <div align={"center"}>
          <Action onClick={this.props.on_add_account} style={style}>
            { text }
          </Action>
        </div>
      )
    }
    return null;
  }

  render = () => {

    const acct_index = parseInt(this.props.acct_index, 10);
    const client = this.props.client;
    const user = this.props.user;
    const tda = this.props.tda;

    const header_style = {
      color: "#000",
      fontSize: "0.8rem",
    }
    const half_div_style = {
      flex: "1",
    };

    let menu_data = [];
    if (this.props.set_menu_data) {
      if (this.props.menu_data) {
        // This is generated by the dashboard, and viewed by the admin
        menu_data = this.props.menu_data;
      }
    } else {
      // This is generated for a viewer
      menu_data = CreateAccountMenuData(user, tda);
    }

    const acct_divs = menu_data.map(({account, type}, index) => {
      const acct_style = {
        color: acct_index === index
          ? getRGB(client.color.sign_on_button)
          : "#000",
        display: "flex",
      };
      if (this.state.mouse_over_menu === index) {
        acct_style.backgroundColor = "#DDD";
      }
      const filter_acct = acct => {
        if (!acct) {
          return acct;
        }
        if (acct.startsWith("TMP-")) {
          return acct.substring(4);
        }
        return acct;
      }
      return (
        <div key={index}
             style={acct_style}
             onMouseOver={this.onMenuMouseOver(index, true)}
             onMouseOut={this.onMenuMouseOver(index, false)}
             onClick={this.onAccountMenuClick(index)}>
          <div style={half_div_style}>
            <span>{filter_acct(account)}</span>
          </div>
          <div style={half_div_style}>
            <span>{type}</span>
          </div>
        </div>
      )
    });

    return (
      <PopupBorder>
        <div style={{display: "flex"}}>
          <div style={half_div_style}>
            <span style={header_style}>Account</span>
          </div>
          <div style={half_div_style}>
            <span style={header_style}>Type</span>
          </div>
        </div>
        <hr style={{backgroundColor: "#000", width: "100%", height: "1px", margin: "0"}}/>
        { acct_divs }
        <div style={{height: "1rem"}}/>
        { this.maybeRenderAddAccount() }
        { this.maybeRenderAggregate() }
      </PopupBorder>
    )
  }
}

export { AccountPopupMenu };
